import { FieldValue } from 'app/area/reports/types';
import { ReportCommonApi } from 'app/area/reports/types-api';
import { CasePermissions, FavouriteDefinition } from 'app/types-shared';

import type { JSX } from "react";

export interface PrimaryActionComponentProps {
  caseId: number;
  permissions?: CasePermissions;
}

export type PrimaryActionComponentFactory = (props: PrimaryActionComponentProps) => JSX.Element;

export enum ReportCategory {
  CaseReport = 1,
  NumeratorReport = 2,
  StatisticalReport = 3,
  DashboardReport = 4,
  SpecialReport = 5,
  CodeTableReport = 6,
  Administrative = 7,
  ModificationReport = 8,
  PersonReport = 9,
  ExportInport = 10,
  CaseReportIntegrations = 11,
  CaseReportInternalUse = 12
}

export enum FolderType {
  SpecialReport = 9,
  Dashboard = 10
}

export interface CaseListingExecuteFavorites {
  definition: FavouriteDefinition;
  loadPermissions: boolean;
  startIndex: number;
  maxResults?: number;
  replaceResult?: boolean;
  overrideExecuteFavourite?: ReportCommonApi['executeFavourite'];
}

export interface CaseIncludedField {
  domain: FieldValue;
  id?: number;
  children?: CaseIncludedField[];
  entityTypePath?: string[];
}
